@let configuration = configurationSg();
@let isStandardUser = isStandardUserSg();

<div class="atn-space-report-rsi">
  <atn-ds-widget title="Configuration">
    <div class="atn-space-report-rsi__configuration">
      <div class="atn-space-report-rsi__selects">
        <atn-ds-select-single
          label="Sort By"
          [items]="sortByItems"
          [value]="configuration.sortBy"
          [required]="true"
          (valueChange)="sortByChangeHandler($event)"
        />
        <atn-ds-select-single
          label="Format"
          [items]="formatItems"
          [value]="configuration.format"
          [required]="true"
          (valueChange)="formatChangeHandler($event)"
        />
      </div>

      <div class="atn-space-report-rsi__checkboxes">
        <atn-ds-checkbox
          label="Show Employee Numbers"
          [selected]="configuration.showEmployeeNumbers"
          (selectedChange)="showEmployeeNumbersChangeHandler($event)"
        />
        @if (!isStandardUser) {
          <atn-ds-checkbox
            label="Show Salary Information"
            [selected]="configuration.showSalaryInformation"
            (selectedChange)="showSalaryInformationChangeHandler($event)"
          />
        }
        <atn-ds-checkbox
          label="Show Calculated Room Functional Percentages"
          [selected]="configuration.showCalculatedRoomFunctionalPercentages"
          (selectedChange)="
            showCalculatedRoomFunctionalPercentagesChangeHandler($event)
          "
        />
        <atn-ds-checkbox
          label="Show Project Information"
          [selected]="configuration.showProjectInformation"
          (selectedChange)="showProjectInformationChangeHandler($event)"
        />
      </div>
    </div>
  </atn-ds-widget>

  <div class="atn-space-report-rsi__filters">
    <atn-ds-widget title="Filters">
      <div class="atn-space-report-rsi__filters-content">
        <atn-ds-section name="Functional Methodology">
          <div class="atn-space-report-rsi__filter-section">
            <atn-ds-select-multiple
              [items]="methodologyItems"
              [value]="configuration.filter.functionalMethodologies"
              (valueChange)="methodologiesChangeHandler($event)"
            />
          </div>
        </atn-ds-section>
        <atn-ds-section name="Organization">
          <div class="atn-space-report-rsi__filter-section">
            <atn-space-dimension-filter [plugin]="organizationFilterPlugin" />
          </div>
        </atn-ds-section>
        <atn-ds-section name="Space">
          <div class="atn-space-report-rsi__filter-section">
            <atn-space-dimension-filter [plugin]="spaceFilterPlugin" />
          </div>
        </atn-ds-section>
        <atn-ds-section name="Responsible Persons">
          <div class="atn-space-report-rsi__filter-section">
            <atn-space-dimension-filter [plugin]="employeeFilterPlugin" />
          </div>
        </atn-ds-section>
        <atn-ds-section name="Room Types">
          <div class="atn-space-report-rsi__filter-section">
            <atn-space-dimension-filter [plugin]="roomTypeFilterPlugin" />
          </div>
        </atn-ds-section>
        <atn-ds-section name="Clusters">
          <div class="atn-space-report-rsi__filter-section">
            <atn-space-dimension-filter [plugin]="clusterFilterPlugin" />
          </div>
        </atn-ds-section>
      </div>
    </atn-ds-widget>
  </div>
</div>
